export default __webpack_public_path__ + "static/media/identite.f8007069.svg";